var bookmarkwithLogin = "";
function getUserDetails(FormData) {
    let formArr = {};
    FormData.forEach(function (value, key) {
        if (key == "email" || key == "phone") {
            formArr[key] = value;
        }
    });
    return formArr;
}

$(document).on("paste", ".otp-input", function (event) {
    const clipboardData = event.originalEvent.clipboardData || window.originalEvent.clipboardData;
    const pastedData = clipboardData.getData("Text");
    let otp = pastedData.trim().replace(/[^\d]/g, "");
    for (let i = 1; i <= 6; i++) {
        $(`#oc${i}`).val("");
    }
    for (let i = 1; i <= otp.length && i <= 6; i++) {
        $(`#oc${i}`).val(otp[i - 1]);
    }
    $(`#oc${otp.length}`).focus();
    // if (otp.length < 6) {
    // }
})



$(document).on("keyup", ".otp-input", function (event) {
    const input = event.target;
    const keyCode = event.keyCode || event.which;

    if (input.value.length >= 1) {
        let nextInput = input.nextElementSibling;
        if (nextInput && nextInput.classList.contains("otp-input")) {
            nextInput.focus();
        }
    }

    // Backspace key
    if (keyCode === 8 && !input.value) {
        let prevInput = input.previousElementSibling;
        if (prevInput && prevInput.classList.contains("otp-input")) {
            prevInput.focus();
        }
    }
});

$(document).on("input", ".otp-input", function (event) {
    const input = event.target;
    input.value = input.value.replace(/[^\d]/g, "");
});

$(document).on("submit", "#otp-verification", async function (e) {
    e.preventDefault();
    var otp = "";
    for (let i = 1; i <= 6; i++) {
        otp += $(`#oc${i}`).val();
    }
    $("#otp").val(otp);
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        generateFormData(this)
    );
    if (data.error) {
        $(".check-otp").val("");
    }
    if (data.success) {
        $.ajax({
            url: dynamicRoutes.register,
            type: "POST",
            data: {
                _token: $('meta[name="csrf-token"]').attr("content"),
                formData: getUserDetails(generateFormData(this)),
            },
            success: function (res) {
                $(".dhn-sign-in-right-form").html(res);
                $("#email").val("");
                $("#password").val("");
                applyTheme();
            },
        });
    }
});

$(document).on("submit", "#sendLoginOtpform", async function (e) {
    e.preventDefault();
    var sendloginUrl = $(this).attr('href');
    console.log(sendloginUrl);

    var otp = "";
    for (let i = 1; i <= 6; i++) {
        otp += $(`#oc${i}`).val();
    }
    $("#otp").val(otp);
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        generateFormData(this)
    );
    if (data.error) {
        $(".check-otp").val("");
    }
    if (data.success) {
        window.location.href = data.route_after;
    }
    if (data.error) {
        $(".check-password").val("");
    }
});

$(document).on("submit", "#register-form", async function (e) {
    e.preventDefault();
    var registerFormData = generateFormData(this);
    registerFormData.append("route", window.location.pathname.replace(/^\/+/, ''));
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        registerFormData
    );

    if (data.success) {
        var data = await ajaxDynamicMethod(
            dynamicRoutes.login,
            "POST",
            registerFormData
        );
        if (data.success) {
            window.location.href = data.route_after;
        }
    }
});

$(document).on("click", "#forgot-password", function (e) {
    e.preventDefault();
    $.ajax({
        url: dynamicRoutes.forgotPassword,
        type: "GET",
        success: function (res) {
            $(".dhn-sign-in-right-form").html(res);
            applyTheme();
        },
    });
});

function startResendOTPTimer(timerInSeconds) {
    var resendBtn = $('#resend-otp');
    var countdown = timerInSeconds;

    resendBtn.addClass('disabled').css('pointer-events', 'none').text(`Resend OTP in ${countdown}s`);

    var timer = setInterval(function () {
        countdown--;
        if (countdown > 0) {
            resendBtn.text(`Resend OTP in ${countdown}s`);
        } else {
            clearInterval(timer);
            resendBtn.removeClass('disabled').css('pointer-events', 'auto').text('Resend OTP');
        }
    }, 1000);
}

$(document).on("click", "#sendlogin-otp", async function (e) {
    e.preventDefault();
    var sendloginOtpUrl = $(this).attr('href');
    var number = $(this).data('number');
    var formData = new FormData();
    formData.append("phone", number);

    const otpResponse = await ajaxDynamicMethod("/api/send-login-otp", "POST", formData);
    if (otpResponse.success === true) {
        const formHtmlResponse = await ajaxDynamicMethod(sendloginOtpUrl, "GET");
        $(".dhn-sign-in-right-form").html(formHtmlResponse);
        applyTheme();
        const timer = formHtmlResponse.data?.resend_timer || 30;
        startResendOTPTimer(timer);
    } else {
        console.error("OTP API failed:", otpResponse);
    }
});

$(document).on("click", "#resend-otp:not(.disabled)", async function (e) {
    e.preventDefault();
    var number = $('input[name="phone"]').val(); // Get the phone number from hidden input
    var formData = new FormData();
    formData.append("phone", number);
    const resendResponse = await ajaxDynamicMethod("/api/send-login-otp", "POST", formData);

    if (resendResponse.success) {
        const timer = resendResponse.data && resendResponse.data.resend_timer ? resendResponse.data.resend_timer : 30;
        startResendOTPTimer(timer);
    }
});

$(document).on("submit", "#forgot-attempt", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        generateFormData(this)
    );
    if (data.success) {
        $("#emailforgoterror").text(
            "We have emailed your password reset link."
        );
        $("#emailforgoterror").removeClass("error-danger");
        $("#emailforgoterror").addClass("error-success");
    } else {
        $("#emailforgoterror").text("Required");
        $("#emailforgoterror").addClass("error-danger");
        $("#emailforgoterror").removeClass("error-success");
    }
});

$(document).on("click", "#resend-otp", async function (e) {
    e.preventDefault();
    let form = $("#otp-verification");
    let email = form.find("input[name='email']");
    let phone = form.find("input[name='phone']");

    $.ajax({
        url: dynamicRoutes.apiFindUser,
        type: "POST",
        data: {
            _token: $('meta[name="csrf-token"]').attr("content"),
            email: email.val(),
            phone: phone.val(),
        },
        success: function (res) {
            // console.log(res);
        },
    });
});

$(document).on("submit", "#login-model", async function (e) {
    e.preventDefault();
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        generateFormData(this)
    );
    console.log(data.data);

    if (data.data.user && data.success) {
        $.ajax({
            url: dynamicRoutes.checkPassword,
            type: "POST",
            data: {
                _token: $('meta[name="csrf-token"]').attr("content"),
                formData: getUserDetails(generateFormData(this)),
            },
            success: function (res) {
                $(".dhn-sign-in-right-form").html(res);
                applyTheme();
            },
        });
    }
    else {
        if (data.success) {
            $.ajax({
                url: dynamicRoutes.verifyOtp,
                type: "POST",
                data: {
                    _token: $('meta[name="csrf-token"]').attr("content"),
                    formData: getUserDetails(generateFormData(this)),
                },
                success: function (res) {
                    $(".dhn-sign-in-right-form").html(res);
                    applyTheme();
                },
            });
        }
    }
});

$(document).on("submit", "#login-attempt", async function (e) {
    e.preventDefault();
    var loginFormData = generateFormData(this);
    loginFormData.append("route", window.location.pathname.replace(/^\/+/, ''));
    var data = await ajaxDynamicMethod(
        $(this).attr("action"),
        $(this).attr("method"),
        loginFormData
    );
    if (data.success) {
        if (bookmarkwithLogin == "") {
            if (data.route_after == "self") {
                location.reload();
            }
            else {
                window.location.href = data.route_after;
            }
        } else {
            await bookmark(bookmarkwithLogin);
            if (data.route_after == "self") {
                location.reload();
            }
            else {
                window.location.href = data.route_after;
            }
        }
    }
    if (data.error) {
        $(".check-password").val("");
    }
});

async function bookmark(url) {
    console.log(url);
    var data = await ajaxDynamicMethod(url, "GET");
    if (data.success) {
        var isActive = data.data.action === "add";
        var $iconEl = $('[data-article="' + url + '"]');
        if (data.data.action == "add") {
            $('[data-article="' + url + '"]').addClass("active");
            $('[data-article="' + url + '"]').attr("aria-pressed", true);
        } else {
            $('[data-article="' + url + '"]').removeClass("active");
            $('[data-article="' + url + '"]').attr("aria-pressed", false);
        }
        var toggledIcon = $iconEl.find('img').data("toggled-icon");
        var newIcon = isActive ? toggledIcon : $iconEl.find('img').data("toggled-off-icon");
        $iconEl.find('img').attr("data-icon", newIcon);
        applyTheme();
    }
}


$(document).on("click", ".userAccessDropDown .userInitials", function (e) {
    e.preventDefault();
    // alert(123);
    if ($(this).parent().find(".account-droupmenu").hasClass("show")) {
        $(this).parent().find(".account-droupmenu").removeClass("show");
    }
    else {
        $(this).parent().find(".account-droupmenu").addClass("show");
    }
});

$(document).on("click", ".signInBtn", function (e) {
    e.preventDefault();
    $.dhnPopup.open({
        popupId: "#dhn-sign-in",
        backdropId: "#dhn-sign-in-backdrop",
        position: "center",
        animation: "fade-in",
        hasBackdrop: true,
        showOnce: "none",
        localStorageKey: "signInPopup",
    });
});

$(document).on("click", ".bookmarkBtn", async function () {
    if (isAuth) {
        await bookmark($(this).data("article"));
    }
    else {
        bookmarkwithLogin = $(this).data("article");
        $(".loginBtn").click();
    }
});
